import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { ConstantsService } from '../../services/constants.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
 
@Component({
  selector: 'app-print-documents',
  templateUrl: './print-documents.component.html',
  styleUrls: ['./print-documents.component.scss']
})
export class PrintDocumentsComponent implements OnInit {
  orderCancelForm: FormGroup;
 
  orderCancelTypes: [];
  orderCancelSubTypes: [];
  isFormValid: Boolean = false;
  msg: string = "";
  isSuccessMsg: Boolean = false;
  isFailureMsg: Boolean = false;
  @Input() channel_code;
  constructor(public modal: NgbActiveModal,
    private omsServiceService: OmsServiceService,
    private constantsService: ConstantsService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private spinnerService: NgxSpinnerService,
    private toastr: ToastrService
  ) { }
 
  serviceTypeID: any
  serviceSubTypeID: any
  orderDetailsData: any
  @Input() orderObj;
  order_id: string = "";
  ngOnInit(): void {
    console.log(this.orderObj, 'fwfwfwe');
    this.orderDetailsData = this.orderObj
    this.order_id = this.orderObj.order.patientinfo.order_id;
    this.serviceTypeID = this.orderObj.order.patientinfo.service_type;
    this.serviceSubTypeID = this.orderObj.order.patientinfo.service_subtype_id;
  }
 
 
  downloadDocument(type,orderDetailsData){
    console.log(`orderDetailsData`, orderDetailsData._id);
    if(type == 'prescription'){
        window.open(environment.prescriptionPrint+orderDetailsData._id,'_blank');  
    }else if(type == 'invoice'){
        window.open(environment.invoiceDownload+orderDetailsData._id,'_blank');
    }
  }
 
  close() {
    this.modal.close();
  }
}